import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import Vuex from 'vuex';
import store from './store';
import { fixResizeObserverWarning } from './utils/resizeObserver';

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Vuex);

// 解决 ResizeObserver 警告问题
fixResizeObserverWarning();

new Vue({
  router,
  store, // 注册 Vuex Store
  render: h => h(App),
}).$mount('#app')